module.exports = __webpack_public_path__ + "7df3e94d194c60cc438df229cfba5634.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./www/assets/sitios/agricolahimalaya/img/pre_fri-detail.jpg
 ** module id = 656
 ** module chunks = 0
 **/